import React from 'react';

import {DocumentVersionContentType} from 'app/acceptance/types';
import {TaskActionDocumentPopover} from 'app/components/general/TaskActionDocumentPopover';
import {AttachOverlay} from 'app/general/overlays';
import {postAsyncJob} from 'app/jobs/postAsyncJob';
import {DIAGRAM_API_URL} from 'app/urls';
import {gt} from 'app/utils/i18n';
import {useAsyncActions} from 'app/utils/redux';

type Props = {
  versionContentType: DocumentVersionContentType;
  versionId: string | number;
  onMouseEnter?: (ev: any) => void;
};

export const PrintDiagramButton = React.forwardRef<HTMLButtonElement, Props>(
  ({versionId, versionContentType, onMouseEnter}: Props, ref) => {
    const actions = useAsyncActions({postAsyncJob});

    return (
      <AttachOverlay
        trigger="click"
        overlay={({overlayProps}) => (
          <TaskActionDocumentPopover
            overlayProps={overlayProps}
            objType={gt('diagram')}
            successMessage={gt('Your diagram has been printed.')}
            title={gt('Print Diagram')}
            verb={gt('print')}
            gerundVerb={gt('printing')}
            downloadLink={true}
            action={() =>
              // now request the diagram to be printed
              actions
                .postAsyncJob({
                  url: DIAGRAM_API_URL,
                  obj: {
                    version_content_type: versionContentType,
                    version_id: versionId,
                  },
                  errorText: gt('Could not print diagram'),
                })
                .then((userJob) => {
                  return {result: userJob.result.url};
                })
            }
          />
        )}
      >
        {(triggers) => (
          <button
            {...triggers}
            onMouseEnter={(ev) => {
              if (onMouseEnter != null) onMouseEnter(ev);
            }}
            ref={(el) => {
              applyRef(ref, el);
              applyRef(triggers.ref, el);
            }}
            type="button"
            title="Download Diagram"
            className="btn d-print-none btn-sm"
          >
            {gt('print')}
          </button>
        )}
      </AttachOverlay>
    );
  }
);

function applyRef<T>(
  ref:
    | React.RefObject<T | null>
    | React.RefCallback<T | null>
    | React.ForwardedRef<HTMLButtonElement>,
  el: T | null
) {
  if (ref != null) {
    // @ts-expect-error typescript complains about updating current, no idea the reason
    typeof ref === 'function' ? ref(el) : (ref.current = el);
  }
}
